export function Footer({ className = '' }: { className?: string }) {
  return (
    <footer className={`footer ${className}`}>
      <a href="https://www.masmedicalstaffing.com/privacy/" target="_blank" rel="noreferrer">
        Privacy Policy
      </a>
      <span>© {new Date().getFullYear()} MAS Medical Staffing</span>
    </footer>
  );
}
